import { useSearchParams } from "react-router-dom";



export const useQueryParams = (param: string) => {
    const [searchParams] = useSearchParams();
    return searchParams.get(param)
}